import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { USER_ROLES } from '@/constants/app';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  const getNavigationPath = (): string => {
    if (!user) return '/dashboard';
    
    switch (user.role) {
      case USER_ROLES.EMPLOYEE:
      case USER_ROLES.ADMIN:
      case USER_ROLES.MANAGER:

        return '/dashboard';
      // case USER_ROLES.STUDENT:
      // case USER_ROLES.PARENT:
        // return '/profile';
      default:
        return '/dashboard';
    }
  };

  if (isAuthenticated && user) {
    const navigationPath = getNavigationPath();
    return <Navigate to={navigationPath} replace />;
  }

  return <>{children}</>;
};